<template>
	<div class="school_list_wrap">
		<div class="gxyx_banenr">
			<img src="../../assets/home/home_banner.png" >
		</div>
		<div class="school_list">
			<div class="school_item" v-for="item in schoolwrap" v-if="schoolwrap.length > 0">
				<div class="top_img">
					<img :src="item.logo" >
				</div>
				<div class="bottom_words">
					<span class="name">{{item.name}}</span>
					<span class="login" @click="goUrl(item.url)">登录</span>
				</div>
			</div>
			<div class="nodataimg" v-if="schoolwrap.length == 0"></div>
			<div class="page_box" v-if="totalPage > 1">
				<navigation 
					:pages="totalPage" 
					:current.sync="page" 
					@navpage="msgListView">
				</navigation>
			</div>
		</div>
	</div>
</template>

<script>
	import { yxfc } from '@/axios'
	import navigation from '@/components/page.vue';
	export default{
		data(){
			return{
				schoolwrap:[],
				totalPage:0,
				page:1
			}
		},
		components:{navigation},
		methods:{
			// 分页
			msgListView(curPage){
				//根据当前页获取数据
				var that = this;
				that.page = curPage;
				that.getdata();
				document.getElementsByClassName("layout").scrollTop = 0;
			},
			// 获取数据
			getdata(){
				var that = this;
				yxfc.settleList({
					page:that.page
				}).then(res => {
					if(res.code == 200){
						that.schoolwrap = res.data.pagedata;
						that.totalPage = res.data.total;
					}
				})
			},
			// 跳转学校登录
			goUrl(url){
				if(url != ""){
					window.open(url)
				}else{
					alert("暂无链接可访问");
				}
			}
		},
		mounted() {
			var that = this;
			that.getdata();
		},
		created() {
			
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss';
	.school_list_wrap{
		.gxyx_banenr{
			position: relative;
			width: 100%;
			img{
				width: 100%;
			}
		}
		.school_list{
			width: $indexWidth;
			margin: auto;
			display: flex;
			flex-wrap: wrap;
			padding-bottom: 60px;
			.school_item{
				cursor: pointer;
				width: 200px;
				height: 200px;
				margin-right: 20px;
				margin-top: 20px;
				.top_img{
					position: relative;
					width: 100px;
					height: 100px;
					margin:40px auto 10px auto;
					img{
						width: 100%;
						width: 100%;
					}
				}
				.bottom_words{
					font-size: 14px;
					font-weight: bold;
					color: #383838;
					line-height: 20px;
					text-align: center;
					.login{
						display: none;
						width: 100px;
						margin: auto;
						background: #bb0000;
						color: #fff;
						line-height: 30px;
						border-radius: 20px;
						height: 30px;
						text-align: center;
					}
				}
			}
			.school_item:hover{
				background: rgba(0,0,0,.1);
				.login{
					display: block;
				}
				.name{
					display: none;
				}
			}
			.school_item:nth-child(5n){
				margin-right: 0;
			}
		}
	}
</style>
